module.exports = __webpack_public_path__ + "static/media/RBLBANK.a4905869.txt";